
import { Button } from "@/components/ui/button";
import { UploadSummaryReportProps } from "./types";
import { StatsCards } from "./StatsCards";
import { ResultTabs } from "./ResultTabs";

export const UploadSummaryReport = ({ stats, onClose }: UploadSummaryReportProps) => {
  const createdGuards = stats.detailedResults.filter(g => g.status === 'created');
  const updatedGuards = stats.detailedResults.filter(g => g.status === 'updated' || (g.status === 'warning' && g.afm));
  const failedGuards = stats.detailedResults.filter(g => g.status === 'error');
  const warningGuards = stats.detailedResults.filter(g => g.status === 'warning');

  const getDefaultTab = () => {
    if (stats.errors > 0) return "failed";
    if (stats.warnings > 0) return "warnings";
    if (stats.updated > 0) return "updated";
    return "created";
  };

  return (
    <div className="space-y-6 p-4">
      <div>
        <h2 className="text-xl font-bold mb-4">Upload Summary Report</h2>
        <StatsCards stats={stats} />
      </div>
      
      <ResultTabs
        createdGuards={createdGuards}
        updatedGuards={updatedGuards}
        warningGuards={warningGuards}
        failedGuards={failedGuards}
        defaultTab={getDefaultTab()}
      />
      
      <div className="flex justify-end mt-6">
        <Button onClick={onClose}>Close Report</Button>
      </div>
    </div>
  );
};
